import React from "react";
import useTheme from "../../../../common/hooks/useTheme";
import CircularGraph from "../common/CircularGraph";
import { useSelector } from "react-redux";
import { RootStatePlatform } from "../../store/platform-slice"; // Using styled-components for styling

const FuelUsage = () => {
  const theme = useTheme();
  const homeData = useSelector(
    (state: RootStatePlatform) => state.platform.dataNutServer.activity_tab
  );

  // Fuel usage data
  const fuelUsageData = [
    {
      index: 1,
      type: "Fat",
      value: Math.round(homeData.fuel_usage.fat),
    },
    {
      index: 2,
      type: "Carb",
      value: Math.round(homeData.fuel_usage.carbs),
    },
  ];

  const totalValue = fuelUsageData.reduce((sum, el) => sum + el.value, 0);

  const getPercentageValues = () => {
    let fatPercentage, carbPercentage;

    fatPercentage = Math.round((fuelUsageData[0].value * 100) / totalValue);
    carbPercentage = 100 - fatPercentage;

    return [fatPercentage, carbPercentage];
  };

  return (
    <div style={styles.container(theme)}>
      <div style={styles.inner}>
        {fuelUsageData.map((el, index: number) => (
          <div key={index} style={styles.detailsContainer}>
            <div
              style={styles.dot(
                index === 1
                  ? theme.colors_ds.PRIMARY_ICON_MAIN
                  : theme.colors_ds.SUCCESS_ICON_MAIN
              )}
            />
            <div style={styles.detail(theme)}>
              {`${el.type} Burn ${el.value} kcal ${
                Number.isNaN(getPercentageValues()[el.index - 1])
                  ? ""
                  : `(${getPercentageValues()[el.index - 1]}%)`
              }`}
            </div>
          </div>
        ))}
      </div>
      <CircularGraph
        value={
          Number.isNaN((fuelUsageData[0].value * 100) / totalValue)
            ? 0
            : Math.round((fuelUsageData[0].value * 100) / totalValue)
        }
        size={107}
        strokeWidth={4}
        label={"Burn"}
        color={theme.colors_ds.PRIMARY_ICON_MAIN}
        backgroundColor={
          totalValue > 0
            ? theme.colors_ds.SUCCESS_ICON_MAIN
            : theme.colors_ds.NEUTRAL_BORDER_WEAK
        }
        type="fuelUsage"
        totalValue={totalValue}
      />
    </div>
  );
};
export default FuelUsage;

const styles = {
  container: (theme: any) => ({
    width: "100%",
    padding: "12px 24px 12px",
    marginTop: "8px",
    marginBottom: "8px",
    borderRadius: "8px",
    border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  }),
  inner: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "8px",
  },
  detailsContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  dot: (color: string) => ({
    width: "7px",
    height: "7px",
    borderRadius: "50%",
    backgroundColor: color,
  }),
  detail: (theme: any) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "12px",
    color: theme.colors_ds.NEUTRAL_TEXT_STRONG,
  }),
};
